import React, { useEffect, useState, useRef } from 'react';
import ReactDOM from 'react-dom';
import Popup from '@/components/Popup/index.jsx';

import imgClose from '@/assets/images/complete/close.png';

import styles from './index.less';

const ViewPhoto=(props)=>{
  const {destory} = props;

  const onClose=()=>{
    destory(false)
  }
  return (
    <section className={styles.center}>
      <div onClick={onClose} className={styles.close}>
        <img src={imgClose} />
      </div>
      <section className={styles.wrap}>
        <img className={styles.photo} src={props.src} />
      </section>
    </section>
  )
}

const ShowViewPhoto=(props)=>{
  return new Promise(resolve=>{
    let popup = Popup(resolve);
    ReactDOM.render(
      <ViewPhoto destory={popup.destory} src={props.src} />,
      popup.dom
    );
  })
}

export default ShowViewPhoto;